import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLogin: false,
  id: '',
  email: '',
  fullName: '',
  profileImage: '',
  role: '',
  accessToken: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, { payload }) => {
      return { ...payload, isLogin: true };
    },
    logout: (state) => {
      return { isLogin: false };
    },
    updateProfile: (state, { payload }) => {
      for (const key of ['id', 'fullName', 'profileImage'])
        if (payload?.[key]) state[key] = payload[key];
    },
  },
});

export const { login, logout, updateProfile } = authSlice.actions;
